import moment from 'moment';

export const formatUnixDate = (value, format = 'DD.MM.YYYY') => {
	if (!value) return '';
	return moment.unix(value).format(format);
};

export const formatDate = (value, format = 'DD.MM.YYYY') => {
	if (!value) return '';
	return moment(value).format(format);
};

export const formatDateTimeIntelligent = (value, format) => {
	if (!value) return '';
	if (format) value = moment(value, format);
	if (moment().isSame(value, 'day')) return moment(value).format('HH:mm');
	if (moment().isSame(value, 'year')) return moment(value).format('DD.MM. HH:mm');
	return moment(value).format('DD.MM.YYYY HH:mm');
};

export const formatDateIntelligent = (value, format) => {
	if (!value) return '';
	if (format) value = moment(value, format);
	if (moment().isSame(value, 'day')) return 'Heute';
	if (moment().isSame(value, 'year')) return moment(value).format('DD.MM.');
	return moment(value).format('DD.MM.YYYY');
};

export const fromNowDate = (value) => {
	if (!value) return '';
	return moment(value).fromNow();
};

const CurrencyFormat = new Intl.NumberFormat(
	'de-DE',
	{ style: 'currency', currency: 'EUR' }
);

export const currencyCentsToEuro = value => CurrencyFormat.format(value / 100 || 0);

export const formatToEuro = value => CurrencyFormat.format(value || 0);

export const formatNumber = (value, options = {}) => {
	const fractionDigits = 'fractionDigits' in options ? options.fractionDigits : 2;

	const multiplier = parseInt(value) === parseFloat(value)
		? 1
		: 10 ** fractionDigits;

	value = `${Math.round(value * multiplier) / multiplier}`;
	let [full, fraction] = value.split('.');

	fraction = fraction ? `,${fraction.padEnd(fractionDigits, '0')}` : '';

	// Maybe there is a better solution for "1234567890" => "1.234.567.890"
	full = full
		.split('') // Reverse string start
		.reverse()
		.join('') // Reverse string end
		.match(/.{1,3}/g) // Split into 3er junks
		.join('.') // Merge junks with dot
		.split('') // Reverse back
		.reverse()
		.join('');

	return `${full}${fraction}`;
};
